import { css } from 'styled-components';

export const typeStyle = {
  h1: css`
    font-size: 2.4rem;
    font-weight: 700;
  `,
  h2: css`
    font-size: 1.6rem;
    font-weight: 700;
  `,
  h3: css`
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: 0.4px;
  `,
  h4: css`
    font-size: 1.2rem;
    font-weight: 700;
  `,
  h5: css`
    font-size: 1rem;
    font-weight: 700;
  `,
  'font-10': css`
    font-size: 1rem;
  `,
  'font-10-semi-bold': css`
    font-size: 1rem;
    font-weight: 600;
  `,
  'font-11': css`
    font-size: 1.1rem;
  `,
  'font-12': css`
    font-size: 1.2rem;
  `,
  'font-12-medium': css`
    font-size: 1.2rem;
    font-weight: 500;
  `,
  'font-12-semi-bold': css`
    font-size: 1.2rem;
    font-weight: 600;
  `,
  'font-13': css`
    font-size: 1.3rem;
  `,
  'font-13-bold': css`
    font-size: 1.3rem;
    font-weight: 700;
  `,
  'font-14': css`
    font-size: 1.4rem;
  `,
  'font-14-bold': css`
    font-size: 1.4rem;
    font-weight: 700;
  `,
  'font-14-semi-bold': css`
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 0.5px;
  `,
  'font-16': css`
    font-size: 16px;
  `,
  'font-18-bold': css`
    font-size: 18px;
    font-weight: 700;
  `,
  'font-20-bold': css`
    font-size: 20px;
    font-weight: 700;
  `,
};
